import React, { useState } from "react";
import styles from "./subEscrowModal.module.css";
import {
  TextField,
  MenuItem,
  Button,
  InputAdornment,
  Switch,
} from "@mui/material";
import { useAllProduct } from "../../../../api-context/commonApiContext";
import config from "../../../../service/config";
import FullScreenLoader from "../../../../reusable/loader/FullScreenLoader";

const SubEscrowModal = ({ selectedRowVal, onClose, selectedEscrow }) => {
  const { setRefreshData, escrowList, loading, setLoading } = useAllProduct();
  const [beneficiaryName, setBeneficiaryName] = useState("");
  const [vanPrefix, setVanPrefix] = useState(
    selectedEscrow?.van_prefix || escrowList.van_prefix
  );
  const [escId, setEscID] = useState(
    selectedEscrow?.main_escrow_id || escrowList.main_escrow_id
  );
  const [subEscId, setSubEscId] = useState("");

  const handleSubmit = () => {
    setLoading(true);
    fetch(`${config.node_api_endpoint}/api/escrow-details`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY,
      },
      body: JSON.stringify({
        main_escrow_id: escId,
        sub_escrow_id: subEscId,
        status: "Active",
        created_at: new Date().toISOString(),
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          setRefreshData(true);
          onClose();
        } else {
          alert(result.message);
        }
      })
      .catch((error) => {
        console.error("Error adding sub escrow:", error);
        setRefreshData(true);
        onClose();
      })
      .finally(() => {
        setLoading(false); // ✅ End loader
      });
  };
  console.log("selectedEscrow", escrowList);

  return (
    <>
      <FullScreenLoader spinning={loading} />
      <div className={styles.modalBackdrop}>
        <div className={styles.modalContainer}>
          <div className="d-flex">
            <div
              style={{ cursor: "pointer" }}
              className="mx-2"
              onClick={onClose}
            >
              &#x2190;
            </div>
            <div className={styles.backButton}>Add Sub Escrow Details</div>
          </div>

          {/* <TextField
          label="Sub Escrow Name"
          variant="outlined"
          fullWidth
          margin="normal"
          value={beneficiaryName}
          onChange={(e) => setBeneficiaryName(e.target.value)}
        /> */}
          <TextField
            label="Virtual Account Number Prefix"
            variant="outlined"
            fullWidth
            margin="normal"
            value={vanPrefix}
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                cursor: "not-allowed",
                pointerEvents: "all",
                backgroundColor: "#F1F1F1",
                borderRadius: "9px",
              },
            }}
            onChange={(e) => setVanPrefix(e.target.value)}
            disabled
          />
          <TextField
            label="Main escrow ID"
            variant="outlined"
            fullWidth
            margin="normal"
            value={escId}
            sx={{
              "& .MuiInputBase-input.Mui-disabled": {
                cursor: "not-allowed",
                pointerEvents: "all",
                backgroundColor: "#F1F1F1",
                borderRadius: "9px",
              },
            }}
            onChange={(e) => setEscID(e.target.value)}
            disabled
          />
          <TextField
            label="Sub escrow ID"
            variant="outlined"
            fullWidth
            margin="normal"
            value={subEscId}
            onChange={(e) => setSubEscId(e.target.value)}
          />

          <Button
            variant="contained"
            fullWidth
            className={styles.submitButton}
            onClick={handleSubmit}
            style={{
              backgroundColor: "#2348AB",
            }}
          >
            Submit
          </Button>
        </div>
      </div>
    </>
  );
};

export default SubEscrowModal;
